<ng-container [ngSwitch]="this.menuSelect">
  <ng-container *ngSwitchCase="'accountMenuModal'">
    <div class="tabs-title">
      <div
        *ngFor="let item of this.accountTabMenuRebuild(this.accountTabMenu)"
        class="tabs-title-row"
        [ngClass]="{ active: this.UiHelper.tabSelected == item.tabId }"
        (click)="this.UiHelper.tabsTitleChange(item.tabId)">
        {{ item.title }}
      </div>
      <div class="tabs-down-row">
        <div class="btn colored blue btn-credit">
          <div class="login-button-text" (click)="SignOutDialogOpener(true)">
            {{ 'logout' | t }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'rightMenu'">
    <div *ngFor="let item of this.accountTabMenuRebuild(this.accountTabMenu, true)" class="mid-container-row" (click)="OpenAccountMobile(item.tabId)">
      <div class="left-svg">
        <image-loader-utils [url]="item.icon" [extraClasses]="item.iconClass"></image-loader-utils>
      </div>
      <div class="mid">{{ item.title }}</div>
      <div class="right"></div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'modalMobil'">
    <div class="account-mobile-horizontal-menu">
      <div
        *ngFor="let item of this.accountTabMenuRebuild(this.accountTabMenu)"
        class="h-menu-item"
        [ngClass]="{ active: this.UiHelper.accountMobileMenu == item.tabId }"
        (click)="changeSelectMenu(item.tabId)">
        {{ item.title }}
      </div>
    </div>
  </ng-container>
</ng-container>
